import personOrFreeTextPicker from './personOrFreeTextPicker'

/** Keep the roster's public Alpine factory compatible while using the shared picker. */
export default (options) => personOrFreeTextPicker({
  ...options,
  optionsSelector: '[data-roster-people-options]'
})
